export const useSxStyles = () => {
  return {
    flex: {
      display: 'flex',
    },
    flexCenter: {
      display: 'flex',
      alignItems: 'center',
    },
  };
};
